module.exports = __webpack_public_path__ + "static/media/why_fi.fdfa5369.vtt";